<template>
  <b-row>
    <b-col lg="12">
      <card>
        <!-- Card header -->
        <h3 slot="header" class="mb-0">Cadastrar Tipo de Requerimento</h3>
        <!-- Card body -->
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form
            class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)"
          >
            <div class="form-row">
              <b-col md="12">
                <base-input
                  label="Título"
                  name="Título"
                  placeholder="Título do tipo de requerimento"
                  success-message="Ok!"
                  rules="required"
                  v-model="form.title"
                >
                </base-input>
              </b-col>

              <b-col md="12">
                <h4>Informações ({{ editorTextLength }})</h4>
                <form :type="1" @input="getInput">
                  <html-editor
                    @input="getInputEditor"
                    @editorTextLength="getEditorTextLength"
                    :value="form.description"
                    :limit-length-text="editorLimitTextLength"
                  ></html-editor>
                </form>
              </b-col>
            </div>

            <base-input
              :rules="{ required: { allowFalse: false } }"
              name="Concordar"
            >
              <b-form-checkbox v-model="form.agree">
                Eu concordo com os termos e condições
              </b-form-checkbox>
            </base-input>

            <base-button
              :disabled="disableSubmitButton"
              type="primary"
              native-type="submit"
              >{{ submitButtonText }}</base-button
            >
          </form>
        </validation-observer>
      </card>
    </b-col>
  </b-row>
</template>
<script>
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import swal from "sweetalert2";
import { Select, Option } from "element-ui";
import bocapioService from "@/services/nodejs/index";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    HtmlEditor
  },
  data() {
    return {
      validated: false,
      submitButtonText: "Enviar",
      showAlert: false,
      disableSubmitButton: false,
      form: {
        title: null,
        description: "<p><br></p>",
        agree: false
      },
      editorTextLength: null,
      editorLimitTextLength: 200,
      issuesSelectOptions: [],
      showInitialTextInfoIssues: true,
      infoIssues: null
    };
  },
  methods: {
    getInput(input) {},
    getInputEditor(payload) {
      this.form.description = payload;
    },
    getEditorTextLength(payload) {
      this.editorTextLength = payload;
    },
    async firstFormSubmit() {
      this.submitButtonText = "Enviando...";
      this.disableSubmitButton = true;
      bocapioService
        .cadastrarTipoRequerimento(this.form.title, this.form.description)
        .then(rsp => {
          console.log("resposta cadastrarTipoRequerimento ", rsp.data);
          this.showSwal(
            "Sucesso!!",
            "Item Criado com sucesso !!",
            "primary",
            "success"
          );
          this.$router.push("/configurations/issuesTypes/index");
        })
        .catch(() => {
          this.$router.push("/configurations/issuesTypes/index");
          this.showSwal(
            "Erro!!",
            "Algo deu errado. Tente novamente mais tarde !!",
            "warning",
            "warning"
          );
          this.disableSubmitButton = false;
        });
    },
    getTiposRequerimentosAtivos() {
      bocapioService.getTiposRequerimentosAtivos().then(rsp => {
        console.log("resposta getTiposRequerimentosAtivos ", rsp.data);
        this.issuesSelectOptions = rsp.data;
      });
    },
    changeSelectItem() {
      var issuesType = this.issuesSelectOptions.find(issuesElem => {
        return issuesElem.id == this.form.selectedTypeIssues;
      });
      this.infoIssues = issuesType.description;
      this.showInitialTextInfoIssues = false;
    },
    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
        icon: icon
      });
    }
  },

  mounted() {
    this.getTiposRequerimentosAtivos();
  }
};
</script>
<style></style>
